import React from "react";
export const contentContext = React.createContext({});
export const appContext = React.createContext({});
export const podcastContext = React.createContext({});

// context for IndividualRetailInvestorContent
export const individualRetailInvestorContext = React.createContext({});
